module.exports = __webpack_public_path__ + "img/speaker-big.31fdfde2.svg";